import styles from "./styles.module.scss";

export function AboutBlock() {
  return (
    <div className={styles.container}>
      <h3 className={styles["overline"]}>Dig deeper</h3>

      <div className={styles.ctas}>
        <p className={styles["cta-text"]}>
          <a
            href={process.env.TECHNICAL_APPENDIX_LINK}
            className={styles["cta-link"]}
            data-layer-event-prefix="Download Link"
            data-layer-action="click"
            data-layer-region="dig deeper"
            data-layer-text="Technical appendix and acknowledgements"
            data-layer-file-name="Global-trade-flows-Appendix-and-acknowledgments"
            data-layer-report-name="Global-trade-flows-Appendix-and-acknowledgments"
            data-layer-report-type="pdf"
          >
            Technical appendix and{" "}
            <span className={styles.hyphenate}>acknowledgements</span>
          </a>
        </p>

        <p className={styles["cta-text"]}>
          <a
            href="https://www.mckinsey.com/mgi/contact"
            className={styles["cta-link"]}
            data-layer-event-prefix="CTA Link"
            data-layer-action="click"
            data-layer-category="share"
            data-layer-subcategory="email"
            data-layer-text="Connect with a McKinsey expert"
            data-layer-region="dig deeper"
          >
            Connect with a McKinsey expert
          </a>
        </p>
      </div>
    </div>
  );
}
